import { HTTPMethod } from 'utils/HTTPUtils';
import { OgObject } from 'networking/mindfeed/types/OgObject';
import { authenticationHeaders } from 'networking/mindfeed/utils/authenticationHeaders';
import { routes } from '../constants/api';
import { apiFetch } from '../utils/apiClient';

export const getUrlPreview = async (targetUrl: string): Promise<OgObject> =>
  apiFetch<OgObject>(routes.cortex.preview(targetUrl), {
    method: HTTPMethod.GET,
    headers: await authenticationHeaders(),
  });
